import { Component, effect, inject, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonDirective, IconDirective } from 'shared/ui-common';
import { OrganisationSettingsService } from 'shared/util-common';

import { FlowchartElementType, FlowchartNodeType } from '@treetop/shared/model';

import { FlowchartSidebarActionComponent } from './flowchart-sidebar-action/flowchart-sidebar-action.component';
import { FlowchartSidebarContainerComponent } from './flowchart-sidebar-container/flowchart-sidebar-container.component';
import { FlowchartSidebarDecisionComponent } from './flowchart-sidebar-decision/flowchart-sidebar-decision.component';
import { FlowchartSidebarLinkComponent } from './flowchart-sidebar-link/flowchart-sidebar-link.component';
import { FlowchartSidebarStartComponent } from './flowchart-sidebar-start/flowchart-sidebar-start.component';
import { FlowchartSidebarTextBlockComponent } from './flowchart-sidebar-textblock/flowchart-sidebar-textblock.component';
import { FlowchartSidebarType, FlowchartSidebarWrapperService } from './flowchart-sidebar-wrapper.service';

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    FlowchartSidebarStartComponent,
    FlowchartSidebarActionComponent,
    FlowchartSidebarDecisionComponent,
    FlowchartSidebarLinkComponent,
    FlowchartSidebarTextBlockComponent,
    FlowchartSidebarDecisionComponent,
    IconDirective,
    MatIconModule,
    TranslocoPipe,
    ButtonDirective,
    FlowchartSidebarContainerComponent,
  ],
  selector: 'guideline-flowchart-sidebar-wrapper',
  templateUrl: './flowchart-sidebar-wrapper.component.html',
  styleUrls: ['./flowchart-sidebar-wrapper.component.scss'],
  providers: [FlowchartSidebarWrapperService],
})
export class GuidelineFlowchartSidebarWrapperComponent {
  protected service = inject(FlowchartSidebarWrapperService);
  protected organisationSettingsService = inject(OrganisationSettingsService);

  public selectedWidgetId = input<string>();
  public selectedElementId = input<string>();

  protected vm = this.service.vm;

  constructor() {
    effect(() => {
      this.service.setSelectedWidgetId(this.selectedWidgetId());
    });

    effect(() => {
      this.service.setSelectedElementId(this.selectedElementId());
    });
  }

  protected handleFlowchartElementDataChanged(flowchartElement: FlowchartNodeType) {
    this.service.handleFlowchartElementDataChanged(flowchartElement);
  }

  protected FlowchartElementType = FlowchartElementType;
  protected readonly FlowchartSidebarType = FlowchartSidebarType;
}
